// src/services/chatService.js
import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Base da API vinda do .env
const API = process.env.REACT_APP_DASHBOARD_API;

// Instância Axios com baseURL do chat
const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// Cria nova config com Authorization: Bearer <ID token> (sem mutar parâmetro)
async function withAuthHeader(config, { forceRefresh = false } = {}) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Missing token');

  const idToken = await user.getIdToken(forceRefresh);
  if (!idToken) throw new Error('Missing token');

  const headers = { ...(config.headers || {}), Authorization: `Bearer ${idToken}` };
  return { ...config, headers };
}

// Request interceptor: injeta o token em toda requisição
api.interceptors.request.use(
  async (config) => withAuthHeader(config),
  (error) => Promise.reject(error)
);

// Response interceptor: tenta 1 retry em 401 com refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;

    if (status === 401 && !original.isRetry) {
      try {
        const retryBase = { ...original, isRetry: true };
        const retryConfig = await withAuthHeader(retryBase, { forceRefresh: true });
        return api.request(retryConfig);
      } catch (e) {
        // segue para o handler abaixo
      }
    }

    return Promise.reject(error);
  }
);

// Busca TODAS as conversas daquele cliente
export const getClienteConversas = async (clienteId) => {
  if (!clienteId) return [];
  const { data } = await api.get(`/conversas/${encodeURIComponent(clienteId)}`);
  // Se a resposta não for array, converte para array de objetos
  return Array.isArray(data) ? data : Object.values(data || {});
};

// Busca UMA conversa específica (por atendimento)
export const getConversaByAtendimento = async (clienteId, atendimentoId) => {
  if (!clienteId || !atendimentoId) return null;
  const { data } = await api.get(
    `/conversas/${encodeURIComponent(clienteId)}/${encodeURIComponent(
      atendimentoId
    )}`
  );
  return data;
};
